import React, { useState, useRef, useEffect, useContext } from 'react';
import '../../common/css/media.css';
import {useInterval, parse_metrics_body, strArraySortAsc, saveIfChange, getMetricProperty} from '../../common/app_common.js';
import {getApiDataQuery, getApiDataQueryRange} from '../../common/fetch_api/data';
import {getApiEdgeIdMetrics, getApiEdgeIdAlertStatusSummary} from '../../common/fetch_api/edge';
import {TitleDetail, TermRefresh, CheckEdgeMetric} from '../../common/component_common.js';
import Collapse from 'react-bootstrap/Collapse';
import {checkApiDataResult, getStartEndStep, makeResultData, valuesTimeDisp, ChartTime,
        DisplayMaxMinValue, timeTextChange,makeMsystemChartData, updateMsystemChartData,
        updateMuxOutputChartData,muxOutputTimeDisp, makeBitrateSumData, simpleTimeDisp,
        updateLlsChartData, unitBpsConvert, updateTsiChartData
        } from './monitoring/monitoring_common.js';
import {areaChartOption, muxOutputChartOption, llsTsiChartOption} from './monitoring/chartsOptions';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { StatusAlertModal } from '../../common/modal_common.js';
import {TermRefreshContext} from '../../pages/sites_list';
import {
    BsChevronDown,
    BsChevronRight,
    BsClock,
    BsFileText,
    BsBoxArrowInRight,
    BsBoxArrowRight,
    BsDiagram2Fill,
    BsServer,
    BsArrowRepeat,
    BsStack,
    BsGearFill,
    BsShieldFillCheck,
    BsPersonBadgeFill,
    BsCardList,
    BsExclamationTriangle,
    BsBoxFill,
    BsListUl
  } from "react-icons/bs";

const TID_COLOR = ['#00FF0E', '#FFA301', '#0dcaf0', '#f47378', '#B080FF', '#FFE700', '#F8A5FA' ];
const TSI_COLOR = ['#82FFA8', '#f47378', '#0dcaf0', '#FFA301', '#949BFF', '#FFE700', '#F8A5FA' ];

const typeIconComponentMap = {
    time: BsClock,
    timesync: BsArrowRepeat,
    input: BsBoxArrowInRight,
    output: BsBoxArrowRight,
    buffer: BsStack,
    module: BsDiagram2Fill,
    host: BsServer,
    system: BsGearFill,
    certificate: BsShieldFillCheck,
    sign: BsPersonBadgeFill,
    lls: BsFileText,
    esg: BsCardList,
    aea: BsExclamationTriangle,
    nrt: BsBoxFill,
    service: BsListUl
};

export function getGidTidServiceData(metricsObj, setState)
{
    if(metricsObj)
    {
        if( metricsObj.hasOwnProperty('a3r_bs_base_info') && metricsObj.a3r_bs_base_info &&
            metricsObj.hasOwnProperty('a3r_bs_lls_version') && metricsObj.a3r_bs_lls_version &&
            metricsObj.hasOwnProperty('a3r_bs_svc_comp_info') && metricsObj.a3r_bs_svc_comp_info &&
            metricsObj.a3r_bs_base_info.length > 0 &&
            metricsObj.a3r_bs_lls_version.length > 0 &&
            metricsObj.a3r_bs_svc_comp_info.length > 0 )
        {
            let baseInfo = metricsObj.a3r_bs_base_info;
            let llsVerInfo = metricsObj.a3r_bs_lls_version;
            let svcInfo = metricsObj.a3r_bs_svc_comp_info;
            
            let gidWithTidArray = [];
        
            baseInfo.forEach(function(item)
            {
                let gidPerTidObj = {};
                let tidArr = [];
                let svcIdArr = [];
                
                let llsVerInfoArr = llsVerInfo.filter((x) => {return x.labels.gid === item.labels.gid});
                let svcInfoArr = svcInfo.filter((x) => {return x.labels.gid === item.labels.gid});
                
                llsVerInfoArr.sort((a, b) => strArraySortAsc(a.labels.tid, b.labels.tid));
                svcInfoArr.sort((a, b) => strArraySortAsc(a.labels.svc_id, b.labels.svc_id));

                llsVerInfoArr.forEach((x) => { tidArr.push(x.labels.tid) });
                svcInfoArr.forEach((x) => { svcIdArr.push(x.labels.svc_id) });

                let svcIdArray = [...new Set(svcIdArr)];

                gidPerTidObj.gid = item.labels.gid;
                gidPerTidObj.tid = tidArr;
                gidPerTidObj.svcId = svcIdArray;
                gidPerTidObj.tsi = [];
                gidPerTidObj.packetId = [];
                gidPerTidObj.protocol = [];

                svcIdArray.forEach(function(x, i)
                {
                    let tsiInfo = svcInfo.filter((y) => {return y.labels.gid === item.labels.gid && y.labels.svc_id === x});

                    tsiInfo.sort((a, b) => strArraySortAsc(a.labels.tsi, b.labels.tsi));
                    tsiInfo.sort((a, b) => strArraySortAsc(a.labels.packetId, b.labels.packetId));

                    let tsiArr = [];
                    let packetIdArr = [];
                    let protocolArr = [];

                    tsiInfo.forEach((y) => { tsiArr.push(y.labels.tsi) });
                    tsiInfo.forEach((y) => { packetIdArr.push(y.labels.packetId) });
                    tsiInfo.forEach((y) => { protocolArr.push(y.labels.protocol) });

                    gidPerTidObj.tsi[i] = tsiArr;
                    gidPerTidObj.packetId[i] = packetIdArr;
                    gidPerTidObj.protocol[i] = protocolArr;
                })

                gidWithTidArray.push(gidPerTidObj);
            })

            saveIfChange(setState, gidWithTidArray);
        }
    }
}

const MediaMonitoring = ({setPageName, siteInfo, edgeInfo}) =>
{
    let termInit = sessionStorage.getItem('term');
    const [term, setTerm] = useState(termInit ?? '1');
    sessionStorage.setItem('term', term);

    let refreshInit = sessionStorage.getItem('refresh');
    const [refresh, setRefresh] = useState(refreshInit ?? 5000);
    sessionStorage.setItem('refresh', refresh);

    if(!siteInfo)
    {
        siteInfo = JSON.parse(sessionStorage.getItem('siteInfo'));
    }

    if(!edgeInfo)
    {
        edgeInfo = JSON.parse(sessionStorage.getItem('edgeInfo'));
    }

    const [isStop, setIsStop] = useState(false);
    const [reload, setReload] = useState(false);
    const [isCalendar, setIsCalendar] = useState(false);

    const [mSystemOpen, setMsystemOpen] = useState(true);
    const [mConfigOpen, setMconfigOpen] = useState(true);
    const [mServiceOpen, setMserviceOpen] = useState(true);

    const [gidTidServiceData, setGidTidServiceData] = useState([]);

    const [metricsObj, setMetricsObj] = useState(null);

    const [update, setUpdate] = useState(false);

    const runUpdate = () => {
        setUpdate(!update);
    };

    useEffect(() =>
    {
        Promise.resolve(getApiEdgeIdMetrics(edgeInfo.id))
        .then(data =>
        {
            let parseBody = parse_metrics_body(data);
            setMetricsObj(parseBody.metrics);
        });
    }, [update]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    useEffect(() =>
    {
        getGidTidServiceData(metricsObj, setGidTidServiceData);
    }, [metricsObj]);

    //MuxOutputChart 컴포넌트에서 받아서, MediaMonitoringStatus 에 전달
    const [muxOutputStatus, setMuxOutputStatus] = useState({lls:'', service:''});

    return (
        <TermRefreshContext.Provider value={{term, refresh, isStop, isCalendar, reload}}>
            <div className="d-flex flex-wrap position-relative">
                {edgeInfo.id && <div className="no-signal-position"><CheckEdgeMetric edgeId={edgeInfo.id} /></div>}
                <TitleDetail setPageName={setPageName} siteName={siteInfo.name} edgeTitle={edgeInfo.name} />
                <TermRefresh setTerm={setTerm} term={term} setRefresh={setRefresh} refresh={refresh} setIsStop={setIsStop} isStop={isStop} reload={reload} setReload={setReload} setIsCalendar={setIsCalendar} isCalendar={isCalendar}/>
            </div>
            <div className="d-flex flex-column media-page mt-2">
                {metricsObj && <MediaMonitoringStatus metricsObj={metricsObj} muxOutputValue={muxOutputStatus} pageName={'mainPage'} edgeId={edgeInfo.id}/>}
                <div className="d-flex div-title" onClick={() => setMsystemOpen(!mSystemOpen)} aria-controls="mSystemTab" aria-expanded={mSystemOpen}>{mSystemOpen?<BsChevronRight/>:<BsChevronDown/>}Digicaster-M System</div>
                <Collapse in={mSystemOpen}>
                    <div id="mSystemTab">
                        <div className="d-flex flex-wrap">
                            {metricsObj && <MsystemInfo metricsObj={metricsObj}/>}
                            <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                                <MediaCpuChart edgeId={edgeInfo.id}/>
                            </div>
                            <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                                <MediaMemChart edgeId={edgeInfo.id}/>
                            </div>
                            <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                                <MediaDiskChart edgeId={edgeInfo.id}/>
                            </div>
                            <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                                <MuxOutputChart edgeId={edgeInfo.id} setMuxOutputStatus={setMuxOutputStatus}/>
                            </div>
                        </div>
                    </div>
                </Collapse>
                <div className="d-flex div-title" onClick={() => setMconfigOpen(!mConfigOpen)} aria-controls="mConfigTab" aria-expanded={mConfigOpen}>{mConfigOpen?<BsChevronRight/>:<BsChevronDown/>}Digicaster-M Config</div>
                <Collapse in={mConfigOpen}>
                    <div id="mConfigTab">
                        <div className="d-flex flex-wrap">
                            {metricsObj && <MconfigInfo metricsObj={metricsObj}/>}
                            <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                                {metricsObj && <SoftwareInfoTable metricsObj={metricsObj}/>}
                            </div>
                            <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                                {metricsObj && <ModuleStatusTable metricsObj={metricsObj}/>}
                            </div>
                        </div>
                    </div>
                </Collapse>
                <div className="d-flex div-title m-service" onClick={() => setMserviceOpen(!mServiceOpen)} aria-controls="mServiceTab" aria-expanded={mServiceOpen}>{mServiceOpen?<BsChevronRight/>:<BsChevronDown/>}Digicaster-M Service</div>
                <Collapse in={mServiceOpen}>
                    <div id="mServiceTab">
                        <div className="d-flex flex-column">
                            {gidTidServiceData.length > 0 && <MakeGroup gidTidServiceData={gidTidServiceData} edgeId={edgeInfo.id}/>}
                        </div>
                    </div>
                </Collapse>
            </div>
        </TermRefreshContext.Provider>
    )
}

export default MediaMonitoring;

export const MediaMonitoringStatus = ({pageName, edgeId}) =>
{
    // const [timeSync, setTimeSync] = useState('');
    // const [timeMode, setTimeMode] = useState('');
    // const [signing, setSigning] = useState('');
    // const [signingLight, setSigningLight] = useState('');
    // const [muxOutput, setMuxOutput] = useState('');
    // const [module, setModule] = useState('');
    // const [ocspStatus, setOcspStatus] = useState('');
    // const [ocspValue, setOcspValue] = useState('');
    // const [system, setSystem] = useState('');

    const [update, setUpdate] = useState(false);
    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    const runUpdate = () => {
        setUpdate(prev => !prev);
    };

    useEffect(() =>
    {
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);
    
    // useEffect(() =>
    // {
    //     if( metricsObj )
    //     {
    //         //saveIfChange 함수에서 같은값이면 setState 를 하지 않게..
    //         if(metricsObj.hasOwnProperty('a3p_digi_mon_timesync') && metricsObj.a3p_digi_mon_timesync.length)
    //         {
    //             let ntpInfo = metricsObj.a3p_digi_mon_timesync[0].labels.status;
    //             saveIfChange(setTimeSync, ntpInfo === 'OK'? 'bg-good' : 'bg-error');
    //         }
    //         else
    //         {
    //             saveIfChange(setTimeSync, '');
    //         }

    //         if(metricsObj.hasOwnProperty('a3p_digi_config_timeSync_info') && metricsObj.a3p_digi_config_timeSync_info.length)
    //         {
    //             saveIfChange(setTimeMode, metricsObj.a3p_digi_config_timeSync_info[0].labels.sync_mode);
    //         }
    //         else
    //         {
    //             saveIfChange(setTimeMode, '');
    //         }

    //         if(metricsObj.hasOwnProperty('a3r_bs_lls_sign') && metricsObj.a3r_bs_lls_sign.length)
    //         {
    //             const signInfo = metricsObj.a3r_bs_lls_sign.filter((x) => {return x.labels.tid === 'CDT'});
    //             saveIfChange(setSigning, signInfo.length > 0 ? 'Signed' : 'Unsigned');
    //             saveIfChange(setSigningLight, 'bg-good');
    //         }
    //         else
    //         {
    //             saveIfChange(setSigning, 'Unsigned');
    //             saveIfChange(setSigningLight, '');
    //         }

    //         if(metricsObj.hasOwnProperty('a3p_digi_mon_module') && metricsObj.a3p_digi_mon_module.length)
    //         {
    //             const moduleInfo = metricsObj.a3p_digi_mon_module;

    //             for (const item of moduleInfo)
    //             {
    //                 if (item.labels.module_status !== 'ok') {
    //                     saveIfChange(setModule, 'bg-error');
    //                     return; // 'error'가 발견되면 즉시 종료
    //                 }
    //             }
    //             // 모든 모듈이 'ok'일 경우에만 'green'으로 설정
    //             saveIfChange(setModule, 'bg-good');
    //         }
    //         else
    //         {
    //             saveIfChange(setModule, '');
    //         }

    //         if(metricsObj.hasOwnProperty('a3r_ocsp_info') && metricsObj.a3r_ocsp_info.length)
    //         {
    //             const ocspInfo = metricsObj.a3r_ocsp_info[0].labels.result;
    //             setOcspValue(ocspInfo.charAt(0).toUpperCase() + ocspInfo.slice(1));

    //             saveIfChange(setOcspStatus, ocspInfo === 'ok'? 'bg-good' : 'bg-error');
    //         }
    //         else
    //         {
    //             saveIfChange(setOcspStatus, '');
    //         }
    //     }
    //     else
    //     {
    //         setTimeSync('');
    //         setTimeMode('');
    //         setSigning('');
    //         setSigningLight('');
    //         setMuxOutput('');
    //         setModule('');
    //         setOcspStatus('');
    //         setOcspValue('');
    //     }
    // }, [metricsObj]);

    // useEffect( () =>
    // {
    //     if( pageName === 'subPage' )
    //     {
    //         let timeOption = getStartEndStep(isCalendar);

    //         Promise.all([
    //             getApiDataQueryRange(`sum(a3r_bs_svc_comp_transmit_bytes{id="${edgeId}"})`, timeOption.start, timeOption.end, timeOption.step),
    //             getApiDataQueryRange(`sum(a3r_bs_lls_transmit_bytes{id="${edgeId}"})`, timeOption.start, timeOption.end, timeOption.step),
    //         ])
    //         .then(( [data1, data2] ) =>
    //         {
    //             if (data1 && data1.data.result.length > 0 && data2 && data2.data.result.length > 0)
    //             {
    //                 let serviceResult = data1.data.result[0].values;
    //                 let llsResult = data2.data.result[0].values;

    //                 let serviceData = makeResultData(timeOption.start, timeOption.end, timeOption.step, serviceResult);
    //                 let llsData = makeResultData(timeOption.start, timeOption.end, timeOption.step, llsResult);

    //                 const muxOutputValue = muxOutputTimeDisp(serviceData, llsData);
    //                 parseMuxOutput(muxOutputValue);
    //             }
    //             else
    //             {
    //                 saveIfChange(setMuxOutput, 'bg-error');
    //             }
    //         });
    //     }
    //     else
    //     {
    //         parseMuxOutput(muxOutputValue);
    //     }
    // }, [update, muxOutputValue]);

    // function parseMuxOutput(muxOutputValue)
    // {
    //     //mux output 에서 {lls: '', service: ''} 이렇게 올때가 있음.
    //     if (muxOutputValue.lls === '' || muxOutputValue.service === '')
    //     {
    //         saveIfChange(setMuxOutput, 'bg-error');
    //     }
    //     else
    //     {
    //         let lls = parseFloat(muxOutputValue.lls.replace(/[^\d.]/g, ""));
    //         let service = parseFloat(muxOutputValue.service.replace(/[^\d.]/g, ""));
    
    //         saveIfChange(setMuxOutput, lls === 0 && service === 0 ? 'bg-error' : 'bg-good');
    //     }
    // }
    
    const [statusData, setStatusData] = useState([]);
    const [modalStatusAlert, setModalStatusAlert] = useState(false);
    const [selectedAlertFilter, setSelectedAlertFilter] = useState('');
    const [selectedAlertName, setSelectedAlertName] = useState('');
    
    const closeModalStatusAlert = () => setModalStatusAlert(false);

    const showModalStatusAlert = (alertFilter, alertName) => {
        setSelectedAlertFilter(alertFilter);
        setSelectedAlertName(alertName);
        setModalStatusAlert(true);
    };

    useEffect(() => {
        getApiEdgeIdAlertStatusSummary(edgeId)
        .then(data => {
            setStatusData(Array.isArray(data) ? data : []);
            // console.log('media statusData', data);
        });
    }, [update]);

    // group별로 데이터 묶기
    const grouped = {};
    (statusData || []).forEach(item => {
        if (!grouped[item.group]) grouped[item.group] = [];
        grouped[item.group].push(item);
    });

    return (
        <div className="d-flex flex-wrap edge-top-status">
            {Object.keys(grouped).map(groupKey => {
                const items = grouped[groupKey].sort((a, b) => a.index - b.index);
                return (
                    <div className="section" key={groupKey}>
                        
                        {items.map((item, idx) => {
                            const IconComponent = typeIconComponentMap[item.type];
                            // 마지막 index인지 판별
                            const isLast = idx === items.length - 1;
                            // className 조건
                            const boxClass =
                                "status-box " +
                                (isLast
                                    ? (pageName === "subPage" ? "me-3" : "")
                                    : (pageName === "subPage" ? "me-1" : "me-2"));
                            return (
                                <div className={boxClass} key={item.type}
                                    style={item.resolvedCount !== 0 ? { cursor: "pointer" } : undefined}
                                    onClick={
                                        item.resolvedCount !== 0
                                            ? () => showModalStatusAlert(item.alertFilter, item.value)
                                            : undefined
                                    }
                                >
                                    <div className="status-header position-relative">
                                        {item.resolvedCount !== 0 && (
                                            <span className="badge-dot bg-warning"></span>
                                        )}
                                        {IconComponent && <IconComponent />}
                                    </div>
                                    <div className={
                                            "status-body" +
                                            (item.value !== "" ? ` bg-${item.status}` : "")
                                        }
                                    >
                                        {item.value}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                );
            })}
        {modalStatusAlert && <StatusAlertModal edgeId={edgeId} alertName={selectedAlertName} alertFilter={selectedAlertFilter} show={modalStatusAlert} handleClose={closeModalStatusAlert} />}
        </div>
    )
}

export const MsystemInfo = ({metricsObj, pageName}) =>
{
    const [sysInfo, setSysInfo] = useState({bsid : '-', gid : '-', utcOffset : '-', signing : '-'});

    useEffect( () => {
        if( metricsObj )
        {
            if(metricsObj.hasOwnProperty('a3r_bs_base_info'))
            {
                setSysInfo(prevState => ({ ...prevState,
                    bsid: metricsObj.a3r_bs_base_info[0].labels.bsid,
                    gid: metricsObj.a3r_bs_base_info[0].labels.gid}));
            }

            if(metricsObj.hasOwnProperty('a3r_bs_utc_offset'))
            {
                setSysInfo(prevState => ({ ...prevState, utcOffset: metricsObj.a3r_bs_utc_offset[0].value}));
            }
        }
    }, [metricsObj]);

    return (
        <div className={`${pageName!=='subPage'?'col-xxl-2 col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 m-system-info':''}`}>
            <div className="section">
                <div className="section-title">BSID</div>
                <div className={`value-label ${pageName!=='subPage'?'x-lg':'lg'}`}>{sysInfo.bsid}</div>
            </div>
            <div className="section">
                <div className="section-title">Group ID</div>
                <div className={`value-label ${pageName!=='subPage'?'x-lg':'lg'}`}>{sysInfo.gid}</div>
            </div>
            <div className="section">
                <div className="section-title">UTC Offset</div>
                <div className={`value-label ${pageName!=='subPage'?'x-lg':'lg'}`}>{sysInfo.utcOffset}</div>
            </div>
        </div>
    )
}

export const MconfigInfo = ({metricsObj, pageName}) =>
{
    const [update, setUpdate] = useState(false);
    const [equipmentName, setEquipmentName] = useState('-');
    const [timeSynchronization, setTimeSynchronization] = useState('-');
    const [mLicense, setMlicense] = useState('-');

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);
    
    useEffect( () =>
    {
        if( metricsObj )
        {
            let temp = null;

            if( temp = getMetricProperty(metricsObj, 'a3p_digi_config_server_info') )
            {
                saveIfChange(setEquipmentName, temp[0].labels.equipment_name);
            }

            if( temp = getMetricProperty(metricsObj, 'a3p_digi_config_timeSync_info') )
            {
                saveIfChange(setTimeSynchronization, temp[0].labels.sync_mode);
            }

            if( temp = getMetricProperty(metricsObj, 'a3p_digi_system_license_info') )
            {
                saveIfChange(setMlicense, temp[0].labels.activation_status.replace(/^[a-z]/, char => char.toUpperCase()));
            }
        }
    }, [metricsObj, update]);

    const runUpdate = () => {
        setUpdate(!update);
    };

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className={`${pageName!=='subPage'?'col-xxl-2 col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 m-config-info':''}`}>
            <div className="section">
                <div className="section-title">Equipment Name</div>
                <div className={`value-label ${pageName!=='subPage'?'x-lg':'lg'}`}>{equipmentName}</div>
            </div>
            <div className="section">
                <div className="section-title">Time Synchronization</div>
                <div className={`value-label ${pageName!=='subPage'?'x-lg':'lg'}`}>{timeSynchronization}</div>
            </div>
            <div className="section">
                <div className="section-title">License</div>
                <div className={`value-label ${pageName!=='subPage'?'x-lg':'lg'}`}>{mLicense}</div>
            </div>
        </div>
    )
}

export const SoftwareInfoTable = ({metricsObj}) =>
{
    const [tbody, setTbody] = useState(null);

    useEffect( () => {
        if( metricsObj )
        {
            if(metricsObj.hasOwnProperty('a3p_digi_system_sw_info'))
            {
                setTbody(metricsObj.a3p_digi_system_sw_info.map((item, i) =>
                (
                    <tr key={i}>
                        <td title={item.labels.module_base_name}>{item.labels.module_base_name}</td>
                        <td title={item.labels.patch_date}>{item.labels.patch_date}</td>
                        <td title={item.labels.version}>{item.labels.version}</td>
                    </tr>
                )))
            }
        }
    }, [metricsObj]);

    return (
        <div className="section software-info">
            <div className="section-title">Software Information</div>
            <div className="software-info-table-area">
                <table className="table text-center table-sm">
                    <thead>
                        <tr>
                            <th>Module</th>
                            <th>Patch Date</th>
                            <th>Version</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tbody}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export const ModuleStatusTable = ({metricsObj}) =>
{
    const [tbody, setTbody] = useState(null);

    useEffect( () => {
        if( metricsObj )
        {
            if(metricsObj.hasOwnProperty('a3p_digi_mon_module'))
            {
                setTbody(metricsObj.a3p_digi_mon_module.map((item, i) =>
                (
                    <tr key={i}>
                        <td title={item.labels.module_name}>{item.labels.module_name}</td>
                        <td title={item.labels.module_status}>{item.labels.module_status}</td>
                    </tr>
                )))
            }
        }
    }, [metricsObj]);

    return (
        <div className="section module-status">
            <div className="section-title">Module Status</div>
            <div className="module-status-table-area">
                <table className="table text-center table-sm">
                    <thead>
                        <tr>
                            <th>Module</th>
                            <th>Stauts Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tbody}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

const MakeGroup = ({gidTidServiceData, edgeId}) =>
{
    const [html, setHtml] = useState(null);

    useEffect( () => {
        setHtml(gidTidServiceData.map((item, i) =>
        (
            <div key={i}>
                <div className="d-flex div-title"><BsChevronRight/>Group-{item.gid}</div>
                {/* 아래에 Collapse 컴포넌트 사용해야함 */}
                <div className="collapse show" id="mGroupTab1">
                    <div className="d-flex flex-wrap">
                        <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                            <LlsChart llsInfo={item} edgeId={edgeId}/>
                        </div>
                        <TidChartList llsInfo={item} edgeId={edgeId}/>
                    </div>
                    <div className="d-flex flex-wrap">
                        <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                            <ServiceInfoTable llsInfo={item} serviceId={item.svcId} edgeId={edgeId}/>
                        </div>
                        <ServiceChartList llsInfo={item} serviceId={item.svcId} edgeId={edgeId}/>
                    </div>
                </div>
            </div>
        )));
    }, [edgeId]);

    return (
        <>
            {html}        
        </>
    )
}
export const LlsChart = ({llsInfo, edgeId}) =>
{
    const [update, setUpdate] = useState(false);
    const setInit = useRef(true);

    const chartRef = useRef(null);

    const chartLastTime = useRef(null);

    const [chartOptions, setChartOptions] = useState(llsTsiChartOption());

    const [displayValues, setDisplayValues] = useState({
        firstTimeLabel: '00:00:00',
        lastTimeLabel: '00:00:00',
        mainValue: '00.00',
        maxValue: '00.00',
        minValue: '00.00'
    });

    const [tidValue, setTidValue] = useState(null);

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        if( llsInfo )
        {
            let timeOption = getStartEndStep(isCalendar);

            Promise.resolve(getApiDataQueryRange(`a3r_bs_lls_transmit_bytes{gid="${llsInfo.gid}", id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step))
            .then( data =>
            {
                if( !checkApiDataResult(data) )
                {
                    let llsData = data.data.result;

                    let subData = data.data.result[0].values;
                    let sumArray = makeBitrateSumData(llsData, subData);

                    let seriesArray = [];

                    for( let [idx, gidItem] of llsData.entries())
                    {
                        let dataArray = makeResultData(timeOption.start, timeOption.end, timeOption.step, gidItem.values);

                        let chartData = makeMsystemChartData(dataArray, 'bitrate');

                        let series = {
                            'name': gidItem.metric.tid,
                            'data': chartData,
                            'color': TID_COLOR[idx]
                        }

                        seriesArray.push(series);
                    }

                    setTidValue(seriesArray);

                    if(setInit.current)
                    {
                        setInit.current = false;
                        chartLastTime.current = seriesArray[0].data[seriesArray[0].data.length - 1][0];

                        setChartOptions({...chartOptions, series: seriesArray});
                    }
                    else if(!setInit.current)
                    {
                        updateLlsChartData(chartRef.current.chart, seriesArray, chartLastTime.current);

                        chartLastTime.current = seriesArray[0].data[seriesArray[0].data.length - 1][0];
                    }

                    setDisplayValues(simpleTimeDisp(sumArray));
                }
            })
        }
    
    }, [update])

    useEffect(() =>
    {
        setInit.current = true;
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className="section lls chart">
            <div className="section-title">LLS</div>
            <div className="d-flex justify-content-between">
                <div className="label lg">bitrate</div>
                <div className="value-label lg">{displayValues.mainValue}</div>
            </div>
            <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} containerProps={{ style: { height: 100 } }} />
            <ChartTime firstTime={displayValues.firstTimeLabel} lastTime={displayValues.lastTimeLabel} />
            <div className="d-flex flex-wrap justify-content-between">
                {tidValue && <TidInfoInLls tidInfo={llsInfo.tid} tidValue={tidValue}/>}
            </div>
        </div>
    )
}

const TidInfoInLls = ({tidValue}) =>
{
    const [html, setHtml] = useState(null);

    useEffect( () => {
        setHtml(tidValue.map((item, i) => (
            <div className="d-flex" key={i}>
                <div className="label sm"><span className="t-color" style={{backgroundColor: `${item.color}`}}></span>{item.name}</div>
                <div className="value-label sm">{unitBpsConvert(item.data[item.data.length - 1][1])}</div>
            </div>
        )))
    }, [tidValue]);

    return (
        <>
            {html}        
        </>
    )
}

const TidChartList = ({llsInfo, edgeId}) =>
{
    const [html, setHtml] = useState(null);

    useEffect( () => {
        setHtml(llsInfo.tid.map((item, i) => (
            <TidChart llsInfo={llsInfo} tidInfo={item} edgeId={edgeId} idx={i} key={i}/>
        )))
    }, [llsInfo]);

    return (
        <>
            {html}        
        </>
    )
}

const TidChart = ({llsInfo, tidInfo, edgeId, idx}) =>
{
    const [update, setUpdate] = useState(false);
    const setInit = useRef(true);

    const chartRef = useRef(null);

    const chartLastTime = useRef(null);

    const [chartOptions, setChartOptions] = useState(llsTsiChartOption());

    const [displayValues, setDisplayValues] = useState({
        firstTimeLabel: '00:00:00',
        lastTimeLabel: '00:00:00',
        mainValue: '00.00',
        maxValue: '00.00',
        minValue: '00.00'
    });

    const runUpdate = () => {
        setUpdate(!update);
    };

    const version = useRef(null);
    const interval = useRef(null);
    const signing = useRef(null);

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let nowTimestamp = Math.floor(new Date().getTime() / 1000);

        Promise.resolve(getApiDataQuery(`a3r_bs_lls_version{gid="${llsInfo.gid}", tid="${tidInfo}", id="${edgeId}"}`, nowTimestamp))
        .then( data =>
        {
            if( !checkApiDataResult(data) )
            {
                version.current = data.data.result[0].value[1];
            }
        });

        Promise.resolve(getApiDataQuery(`a3r_bs_lls_interval_ms{gid="${llsInfo.gid}", tid="${tidInfo}", id="${edgeId}"}`, nowTimestamp))
        .then( data =>
        {
            if( !checkApiDataResult(data) )
            {
                interval.current = data.data.result[0].value[1];
            }
        });

        Promise.resolve(getApiDataQuery(`a3r_bs_lls_sign{gid="${llsInfo.gid}", tid="${tidInfo}", id="${edgeId}"}`, nowTimestamp))
        .then( data =>
        {
            if( !checkApiDataResult(data) )
            {
                signing.current = data.data.result[0].value[1];
            }
        });

        let timeOption = getStartEndStep(isCalendar);

        Promise.resolve(getApiDataQueryRange(`a3r_bs_lls_transmit_bytes{gid="${llsInfo.gid}", tid="${tidInfo}", id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step))
        .then( data =>
        {
            if( !checkApiDataResult(data) )
            {
                let resultValues = data.data.result[0].values;

                let result = makeResultData(timeOption.start, timeOption.end, timeOption.step, resultValues);

                if(setInit.current)
                {
                    setInit.current = false;
                    chartLastTime.current = result[result.length - 1][0];
                    let data = makeMsystemChartData(result, 'bitrate');

                    let series = {
                        'name': tidInfo,
                        'data': data,
                        'color': TID_COLOR[idx]
                    }

                    setChartOptions({...chartOptions, series: series});
                }
                else if(!setInit.current)
                {
                    updateMsystemChartData(chartRef.current.chart, result, chartLastTime.current, 0, 'bitrate');

                    chartLastTime.current = result[result.length - 1][0];
                }

                setDisplayValues(simpleTimeDisp(result));
            }
        })
    
    }, [update])

    useEffect(() =>
    {
        setInit.current = true;
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            <div className="section chart">
                <div className="section-title">{tidInfo}</div>
                <div className="d-flex justify-content-between">
                    <div className="label lg">bitrate</div>
                    <div className="value-label lg">{displayValues.mainValue}</div>
                </div>
                <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} containerProps={{ style: { height: 100 } }} />
                <ChartTime firstTime={displayValues.firstTimeLabel} lastTime={displayValues.lastTimeLabel} />
                <div className="d-flex justify-content-between">
                    <div className="label md">Version</div>
                    <div className="value-label md">{version.current || '-'}</div>
                </div>
                <div className="d-flex justify-content-between">
                    <div className="label md">Interval</div>
                    <div className="value-label md">{interval.current || '-'}</div>
                </div>
                <div className="d-flex justify-content-between">
                    <div className="label md">Signed</div>
                    <div className="value-label md">{signing.current || signing.current !== '0' ? 'NO' : 'YES'}</div>
                </div>
            </div>
        </div>
    )
}

export const ServiceInfoTable = ({llsInfo, serviceId, edgeId}) =>
{
    const [html, setHtml] = useState(null);
    
    useEffect(() =>
    {
        let nowTimestamp = Math.floor(new Date().getTime() / 1000);

        if( llsInfo )
        {
            Promise.resolve(getApiDataQuery(`a3r_bs_slt_info{gid="${llsInfo.gid}", tid="slt", id="${edgeId}"}`, nowTimestamp))
            .then(data =>
            {
                if( !checkApiDataResult(data) )
                {
                    let result = data.data.result;

                    result.sort(function(a, b){
                        return parseFloat(a.metric.svc_id) - parseFloat(b.metric.svc_id);
                    });

                    setHtml(result.map((item, i) =>
                    (
                        <tr key={i}>
                            <td title={item.metric.svc_name}>{item.metric.svc_name}</td>
                            <td title={item.metric.svc_id}>{item.metric.svc_id}</td>
                            <td title={item.metric.category}>{item.metric.category}</td>
                            {/* <td></td> */}
                            <td title={'temp'} className='text-end' id={`gid${llsInfo.gid}svcTbodyBitrate${serviceId[i]}`}></td>
                        </tr>
                    )))
                }
            });
        }
    }, [llsInfo]);

    return (
        <div className="section service-info">
            <div className="section-title">Service Info</div>
            <div className={`service-info-table-area`}>
                <table className="table text-center table-sm">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>SvcId</th>
                            <th>Category</th>
                            <th>Bitrate</th>
                        </tr>
                    </thead>
                    <tbody>
                        {html}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

const ServiceChartList = ({llsInfo, serviceId, edgeId}) =>
{
    const [html, setHtml] = useState(null);

    useEffect( () => {
        setHtml(serviceId.map((item, i) => (
            <ServiceChart llsInfo={llsInfo} serviceId={item} edgeId={edgeId} key={i}/>
        )))
    }, [serviceId]);

    return (
        <>
            {html}        
        </>
    )
}

const ServiceChart = ({llsInfo, serviceId, edgeId}) =>
{
    const [update, setUpdate] = useState(false);
    const setInit = useRef(true);

    const chartRef = useRef(null);

    const chartLastTime = useRef(null);

    const [chartOptions, setChartOptions] = useState(llsTsiChartOption());

    const [displayValues, setDisplayValues] = useState({
        firstTimeLabel: '00:00:00',
        lastTimeLabel: '00:00:00',
        mainValue: '00.00',
        maxValue: '00.00',
        minValue: '00.00'
    });

    const [tsiBitrate, setTsiBitrate] = useState(null);

    const [tsiSectionInfo, setTsiSectionInfo] = useState({
        serviceName: '-',
        serviceId: '-',
        category: '-'
    });

    const [componentInfo, setComponentInfo] = useState(null);
    const [componentBitrate, setComponentBitrate] = useState(null);
    
    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let timeOption = getStartEndStep(isCalendar);

        let protocolType = '';
        let protocolId = '';

        let svcChartDataArray = [];
        let svcSectionArray = [];
        let bitrateValueArray = [];

        for( let [idx, tsi] of llsInfo.tsi[llsInfo.svcId.indexOf(serviceId)].entries() )
        {
            if(llsInfo.protocol[llsInfo.svcId.indexOf(serviceId)][idx] === 'route')
            {
                protocolType = 'tsi';
                protocolId = tsi;
            }
            else
            {
                protocolType = 'packetId';
                protocolId = llsInfo.packetId[llsInfo.svcId.indexOf(serviceId)][idx];
            }

            // console.log(`a3r_bs_svc_comp_transmit_bytes{gid="${llsInfo.gid}", svc_id="${serviceId}", ${protocolType}="${protocolId}", id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step)
            svcChartDataArray.push(getApiDataQueryRange(`a3r_bs_svc_comp_transmit_bytes{gid="${llsInfo.gid}", svc_id="${serviceId}", ${protocolType}="${protocolId}", id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step));

            svcSectionArray.push(getApiDataQuery(`a3r_bs_svc_comp_info{gid="${llsInfo.gid}", svc_id="${serviceId}", ${protocolType}="${protocolId}", id="${edgeId}"}`, timeOption.end));

            bitrateValueArray.push(getApiDataQuery(`a3r_bs_svc_comp_transmit_bytes{gid="${llsInfo.gid}", svc_id="${serviceId}", ${protocolType}="${protocolId}", id="${edgeId}"}`, timeOption.end));
        };

        Promise.all( svcChartDataArray )
        .then( data =>
        {
            if (data.length > 0 && data[0].data.result.length > 0)
            {
                let seriesArray = [];

                let sumDataArray = [];

                for( let [idx, tsiItem] of data.entries() )
                {
                    let tsiData = tsiItem.data.result[0].values;

                    let dataArray = makeResultData(timeOption.start, timeOption.end, timeOption.step, tsiData);

                    let chartData = makeMsystemChartData(dataArray, 'bitrate');

                    let series = {
                        'name': tsiItem.data.result[0].metric.component_type,
                        'data': chartData,
                        'color': TSI_COLOR[idx]
                    }
                    seriesArray.push(series);

                    //data sum 구하기 위해
                    sumDataArray.push(chartData);
                }

                if(setInit.current)
                {
                    setInit.current = false;
                    chartLastTime.current = seriesArray[0].data[seriesArray[0].data.length - 1][0];

                    setChartOptions({...chartOptions, series: seriesArray});
                }
                else if(!setInit.current)
                {
                    updateTsiChartData(chartRef.current.chart, seriesArray, chartLastTime.current);

                    chartLastTime.current = seriesArray[0].data[seriesArray[0].data.length - 1][0];
                }

                // tsi bitrate 합 계산
                let sumArray = [];
                for(let i = 0; i < seriesArray[0].data.length; i++)
                {
                    let dataTemp = [];
                    let time;
                    let value = 0;
                    for(let j = 0; j < sumDataArray.length; j++)
                    {
                        time = sumDataArray[j][i][0];
                        value += sumDataArray[j][i][1];
                    }
                    dataTemp.push(time);
                    dataTemp.push(String(Math.ceil(value)));

                    sumArray.push(dataTemp);
                }

                //sum value 값
                setTsiBitrate(sumArray);

                setDisplayValues(simpleTimeDisp(data[0].data.result[0].values));

                //sercie info table 의 bitrate 값 전달이 어려워 id로 처리
                document.getElementById(`gid${llsInfo.gid}svcTbodyBitrate${serviceId}`).textContent = unitBpsConvert(sumArray[sumArray.length - 1][1]);
            }
        });

        Promise.all( svcSectionArray )
        .then( data =>
        {
            if (data.length > 0 && data[0].data.result.length > 0)
            {
                setTsiSectionInfo({
                    serviceName: data[0].data.result[0].metric.svc_name,
                    serviceId: data[0].data.result[0].metric.svc_id,
                    category: data[0].data.result[0].metric.category
                });

                setComponentInfo(data);
            }
        });

        Promise.all( bitrateValueArray )
        .then( data =>
        {
            if (data.length > 0 && data[0].data.result.length > 0)
            {
                setComponentBitrate(data);
            }
        });

    }, [update])

    useEffect(() =>
    {
        setInit.current = true;
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            <div className="section chart">
                <div className="section-title">{`${tsiSectionInfo.serviceName} (${tsiSectionInfo.serviceId})`}</div>
                <div className="d-flex justify-content-between">
                    <div className="label lg">bitrate</div>
                    <div className="value-label lg">{tsiBitrate && unitBpsConvert(tsiBitrate[tsiBitrate.length - 1][1])}</div>
                </div>
                <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} containerProps={{ style: { height: 100 } }} />
                <ChartTime firstTime={displayValues.firstTimeLabel} lastTime={displayValues.lastTimeLabel} />
                <div className="d-flex justify-content-between">
                    <div className="label md">Category</div>
                    <div className="value-label md">{tsiSectionInfo.category}</div>
                </div>
                <div className="d-flex flex-column component">
                    <div className="d-flex component-head-title" data-bs-toggle="collapse" aria-expanded="true" href="#component1Tab">Component<BsChevronRight className="component-head-title"/></div>
                    <div className="collapse show" id="component1Tab">
                        {componentInfo && <ComponentHtml componentInfo={componentInfo} componentBitrate={componentBitrate}/>}
                    </div>
                </div>
            </div>
        </div>
    )
}

const ComponentHtml = ({componentInfo, componentBitrate}) =>
{
    const [html, setHtml] = useState(null);

    useEffect( () => {
        setHtml(componentInfo.map((item, i) =>
        (
        <div key={i}>
            <div className="component-title" style={{color: `${TSI_COLOR[i]}`}}>{item.data.result[0].metric.component_type}</div>
            <div className="d-flex justify-content-between">
                <div className="label md">{item.data.result[0].metric.protocol === 'route' ? 'TSI' : 'PacketId'}</div>
                <div className="value-label md">{item.data.result[0].metric.protocol === 'route' ? item.data.result[0].metric.tsi : item.data.result[0].metric.packetId}</div>
            </div>
            <div className="d-flex justify-content-between">
                <div className="label md">Protocol</div>
                <div className="value-label md">{item.data.result[0].metric.protocol}</div>
            </div>
            <div className="d-flex justify-content-between">
                <div className="label md">Dest IP/Port</div>
                <div className="value-label md">{`${item.data.result[0].metric.dIpAddr}:${item.data.result[0].metric.dPort}`}</div>
            </div>
            <div className="d-flex justify-content-between">
                <div className="label md">Bitrate</div>
                <div className="value-label md">{componentBitrate && unitBpsConvert(componentBitrate[i].data.result[0].value[1] * 8)}</div>
            </div>
        </div>
        )))
    }, [componentBitrate, componentInfo]);

    return (
        <>
            {html}        
        </>
    )
}

export const MediaCpuChart = ({edgeId}) =>
{
    const [update, setUpdate] = useState(false);
    const setInit = useRef(true);

    const chartRef = useRef(null);

    const chartLastTime = useRef(null);

    const [chartOptions, setChartOptions] = useState(areaChartOption('CPU Usage', 100, '%'));

    const [displayValues, setDisplayValues] = useState({
        firstTimeLabel: '00:00:00',
        lastTimeLabel: '00:00:00',
        mainValue: '00.00',
        maxValue: '00.00',
        minValue: '00.00'
    });

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let timeOption = getStartEndStep(isCalendar);
        
        Promise.resolve(getApiDataQueryRange(`a3p_com_cpu_usage{id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step))
        .then(( data ) =>
        {
            if( !checkApiDataResult(data) )
            {
                let resultValues = data.data.result[0].values;

                let result = makeResultData(timeOption.start, timeOption.end, timeOption.step, resultValues);

                if(setInit.current)
                {
                    setInit.current = false;
                    chartLastTime.current = result[result.length - 1][0];

                    let data = makeMsystemChartData(result, null);

                    setChartOptions({...chartOptions, series: [{data: data}]});
                }
                else if(!setInit.current)
                {
                    updateMsystemChartData(chartRef.current.chart, result, chartLastTime.current, 0, null);

                    chartLastTime.current = result[result.length - 1][0];
                }

                setDisplayValues(valuesTimeDisp(result));
            }
        })
    
    }, [update]);

    useEffect(() =>
    {
        setInit.current = true;
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className="section chart">
            <div className="section-title">CPU</div>
            <div className="d-flex justify-content-between">
                <div className="label lg">Usage</div>
                <div className="value-label lg">{displayValues.mainValue}%</div>
            </div>
            <div className="d-flex invisible">
                <div className="label lg">&nbsp;</div>
                <div className="value-label lg">&nbsp;</div>
            </div>
            <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} containerProps={{ style: { height: 100 } }} />
            <ChartTime firstTime={displayValues.firstTimeLabel} lastTime={displayValues.lastTimeLabel} />
            <DisplayMaxMinValue term={timeTextChange(term, isCalendar)} max={displayValues.maxValue} min={displayValues.minValue} unit={'%'} />
        </div>
    )
}

export const MediaMemChart = ({edgeId}) =>
{
    const [update, setUpdate] = useState(false);
    const setInit = useRef(true);

    const chartRef = useRef(null);

    const chartLastTime = useRef(null);

    const [chartOptions, setChartOptions] = useState(areaChartOption('Memory Usage', 100, '%'));

    const [displayValues, setDisplayValues] = useState({
        firstTimeLabel: '00:00:00',
        lastTimeLabel: '00:00:00',
        mainValue: '00.00',
        maxValue: '00.00',
        minValue: '00.00'
    });

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let timeOption = getStartEndStep(isCalendar);

        Promise.resolve(getApiDataQueryRange(`a3p_com_memory_usage{id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step))
        .then(( data ) =>
        {
            if( !checkApiDataResult(data) )
            {
                let resultValues = data.data.result[0].values;

                let result = makeResultData(timeOption.start, timeOption.end, timeOption.step, resultValues);

                if(setInit.current)
                {
                    setInit.current = false;
                    chartLastTime.current = result[result.length - 1][0];
                    
                    let data = makeMsystemChartData(result, null);

                    setChartOptions({...chartOptions, series: [{data: data}]});
                }
                else if(!setInit.current)
                {
                    updateMsystemChartData(chartRef.current.chart, result, chartLastTime.current, 0, null);

                    chartLastTime.current = result[result.length - 1][0];
                }

                setDisplayValues(valuesTimeDisp(result));
            }
        })
    
    }, [update])

    useEffect(() =>
    {
        setInit.current = true;
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className="section chart">
            <div className="section-title">MEM</div>
            <div className="d-flex justify-content-between">
                <div className="label lg">Usage</div>
                <div className="value-label lg">{displayValues.mainValue}%</div>
            </div>
            <div className="d-flex invisible">
                <div className="label lg">&nbsp;</div>
                <div className="value-label lg">&nbsp;</div>
            </div>
            <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} containerProps={{ style: { height: 100 } }} />
            <ChartTime firstTime={displayValues.firstTimeLabel} lastTime={displayValues.lastTimeLabel} />
            <DisplayMaxMinValue term={timeTextChange(term, isCalendar)} max={displayValues.maxValue} min={displayValues.minValue} unit={'%'} />
        </div>
    )
}

export const MediaDiskChart = ({edgeId}) =>
{
    const [update, setUpdate] = useState(false);
    const setInit = useRef(true);

    const chartRef = useRef(null);

    const chartLastTime = useRef(null);

    const [chartOptions, setChartOptions] = useState(areaChartOption('Disk Usage', 100, '%'));

    const [displayValues, setDisplayValues] = useState({
        firstTimeLabel: '00:00:00',
        lastTimeLabel: '00:00:00',
        mainValue: '00.00',
        maxValue: '00.00',
        minValue: '00.00'
    });

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let timeOption = getStartEndStep(isCalendar);
        
        Promise.resolve(getApiDataQueryRange(`a3p_com_disk_usage{id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step))
        .then(( data ) =>
        {
            if( !checkApiDataResult(data) )
            {
                let resultValues = data.data.result[0].values;

                let result = makeResultData(timeOption.start, timeOption.end, timeOption.step, resultValues);

                if(setInit.current)
                {
                    setInit.current = false;
                    chartLastTime.current = result[result.length - 1][0];
                    
                    let data = makeMsystemChartData(result, null);

                    setChartOptions({...chartOptions, series: [{data: data}]});
                }
                else if(!setInit.current)
                {
                    updateMsystemChartData(chartRef.current.chart, result, chartLastTime.current, 0, null);

                    chartLastTime.current = result[result.length - 1][0];
                }

                setDisplayValues(valuesTimeDisp(result));
            }
        })
    
    }, [update])

    useEffect(() =>
    {
        setInit.current = true;
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className="section chart">
            <div className="section-title">DISK</div>
            <div className="d-flex justify-content-between">
                <div className="label lg">Usage</div>
                <div className="value-label lg">{displayValues.mainValue}%</div>
            </div>
            <div className="d-flex invisible">
                <div className="label lg">&nbsp;</div>
                <div className="value-label lg">&nbsp;</div>
            </div>
            <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} containerProps={{ style: { height: 100 } }} />
            <ChartTime firstTime={displayValues.firstTimeLabel} lastTime={displayValues.lastTimeLabel} />
            <DisplayMaxMinValue term={timeTextChange(term, isCalendar)} max={displayValues.maxValue} min={displayValues.minValue} unit={'%'} />
        </div>
    )
}

export const MuxOutputChart = ({edgeId, setMuxOutputStatus}) =>
{
    const [update, setUpdate] = useState(false);
    const setInit = useRef(true);

    const chartRef = useRef(null);

    const chartLastTime = useRef(null);

    const [chartOptions, setChartOptions] = useState(muxOutputChartOption());

    const [displayValues, setDisplayValues] = useState({
        firstTimeLabel: '00:00:00',
        lastTimeLabel: '00:00:00',
        service: '00.00',
        lls: '00.00',
        maxValue: '00.00',
        minValue: '00.00'
    });

    const runUpdate = () => {
        setUpdate(!update);
    };

    const {term, refresh, isStop, isCalendar, reload} = useContext(TermRefreshContext);

    useEffect(() =>
    {
        let timeOption = getStartEndStep(isCalendar);
        
        Promise.all([
            getApiDataQueryRange(`sum(a3r_bs_svc_comp_transmit_bytes{id="${edgeId}"})`, timeOption.start, timeOption.end, timeOption.step),
            getApiDataQueryRange(`sum(a3r_bs_lls_transmit_bytes{id="${edgeId}"})`, timeOption.start, timeOption.end, timeOption.step),
        ])
        .then(( [data1, data2] ) =>
        {
            if (data1 && data1.data.result.length > 0 && data2 && data2.data.result.length > 0)
            {
                let serviceResult = data1.data.result[0].values;
                let llsResult = data2.data.result[0].values;

                let serviceData = makeResultData(timeOption.start, timeOption.end, timeOption.step, serviceResult);
                let llsData = makeResultData(timeOption.start, timeOption.end, timeOption.step, llsResult);

                if(setInit.current)
                {
                    setInit.current = false;
                    chartLastTime.current = serviceData[serviceData.length - 1][0];

                    let serviceDataArray = makeMsystemChartData(serviceData, 'bitrate');
                    let llsDataArray = makeMsystemChartData(llsData, 'bitrate');

                    setChartOptions({...chartOptions, series: [{data: llsDataArray},{data: serviceDataArray}]});
                }
                else if(!setInit.current)
                {
                    updateMuxOutputChartData(chartRef.current.chart,  serviceData, llsData, chartLastTime.current);

                    chartLastTime.current = serviceData[serviceData.length - 1][0];
                }

                const muxOutputValue = muxOutputTimeDisp(serviceData, llsData);
                setDisplayValues(muxOutputValue);

                // MediaMonitoringStatus 컴포넌트에 전달하기위해
                setMuxOutputStatus({lls:muxOutputValue.lls, service:muxOutputValue.service});
            }
            else
            {
                setMuxOutputStatus({lls:'', service:''});
            }
        });
    
    }, [update])

    useEffect(() =>
    {
        setInit.current = true;
        runUpdate();
    }, [term, reload]);

    useInterval(() =>
    {
        runUpdate();
    }, isStop ? null : refresh);

    return (
        <div className="section mux-output chart">
            <div className="section-title">MuxOutput</div>
            <div className="d-flex justify-content-between">
                <div className="label lg">Service Bitrate</div>
                <div className="value-label lg">{displayValues.service}</div>
            </div>
            <div className="d-flex justify-content-between">
                <div className="label lg">LLS Bitrate</div>
                <div className="value-label lg">{displayValues.lls}</div>
            </div>
            <HighchartsReact ref={chartRef} highcharts={Highcharts} options={chartOptions} containerProps={{ style: { height: 100 } }} />
            <ChartTime firstTime={displayValues.firstTimeLabel} lastTime={displayValues.lastTimeLabel} />
            <DisplayMaxMinValue term={timeTextChange(term, isCalendar)} max={displayValues.maxValue} min={displayValues.minValue} />
        </div>      
    )
}

export const ServiceInfoTableForDash = ({llsInfo, serviceId, edgeId, isCalendar}) =>
{
    const [html, setHtml] = useState(null);
   
    useEffect(() =>
    {
        let nowTimestamp = Math.floor(new Date().getTime() / 1000);
 
        if( llsInfo )
        {
            Promise.resolve(getApiDataQuery(`a3r_bs_slt_info{gid="${llsInfo.gid}", tid="slt", id="${edgeId}"}`, nowTimestamp))
            .then(data =>
            {
                if( !checkApiDataResult(data) )
                {
                    let result = data.data.result;
 
                    result.sort(function(a, b){
                        return parseFloat(a.metric.svc_id) - parseFloat(b.metric.svc_id);
                    });
 
                    setHtml(result.map((item, i) =>
                    (
                        <tr key={i}>
                            <td title={item.metric.svc_name}>{item.metric.svc_name}</td>
                            <td title={item.metric.svc_id}>{item.metric.svc_id}</td>
                            <td title={item.metric.category}>{item.metric.category}</td>
                            {/* <td></td> */}
                            <td title={'temp'} className='text-end' id={`gid${llsInfo.gid}svcTbodyBitrate${serviceId[i]}`}></td>
                        </tr>
                    )))
                }
            });
        }
    }, [llsInfo]);
 
    useEffect( () => {
        if( !html || !llsInfo ) return;
 
        for( const item of serviceId )
        {
            let timeOption = getStartEndStep(isCalendar);
 
            let protocolType = '';
            let protocolId = '';
 
            let svcChartDataArray = [];
            let svcSectionArray = [];
            let bitrateValueArray = [];
 
            for( let [idx, tsi] of llsInfo.tsi[llsInfo.svcId.indexOf(item)].entries() )
            {
                if(llsInfo.protocol[llsInfo.svcId.indexOf(item)][idx] === 'route')
                {
                    protocolType = 'tsi';
                    protocolId = tsi;
                }
                else
                {
                    protocolType = 'packetId';
                    protocolId = llsInfo.packetId[llsInfo.svcId.indexOf(item)][idx];
                }
 
                // console.log(`a3r_bs_svc_comp_transmit_bytes{gid="${llsInfo.gid}", svc_id="${serviceId}", ${protocolType}="${protocolId}", id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step)
                svcChartDataArray.push(getApiDataQueryRange(`a3r_bs_svc_comp_transmit_bytes{gid="${llsInfo.gid}", svc_id="${item}", ${protocolType}="${protocolId}", id="${edgeId}"}`, timeOption.start, timeOption.end, timeOption.step));
 
                svcSectionArray.push(getApiDataQuery(`a3r_bs_svc_comp_info{gid="${llsInfo.gid}", svc_id="${item}", ${protocolType}="${protocolId}", id="${edgeId}"}`, timeOption.end));
 
                bitrateValueArray.push(getApiDataQuery(`a3r_bs_svc_comp_transmit_bytes{gid="${llsInfo.gid}", svc_id="${item}", ${protocolType}="${protocolId}", id="${edgeId}"}`, timeOption.end));
            };
 
            Promise.all( svcChartDataArray )
            .then( data =>
            {
                if (data.length > 0 && data[0].data.result.length > 0)
                {
                    let seriesArray = [];
 
                    let sumDataArray = [];
 
                    for( let [idx, tsiItem] of data.entries() )
                    {
                        let tsiData = tsiItem.data.result[0].values;
 
                        let dataArray = makeResultData(timeOption.start, timeOption.end, timeOption.step, tsiData);
 
                        let chartData = makeMsystemChartData(dataArray, 'bitrate');
 
                        let series = {
                            'name': tsiItem.data.result[0].metric.component_type,
                            'data': chartData,
                            'color': TSI_COLOR[idx]
                        }
                        seriesArray.push(series);
 
                        //data sum 구하기 위해
                        sumDataArray.push(chartData);
                    }
 
                    // tsi bitrate 합 계산
                    let sumArray = [];
                    for(let i = 0; i < seriesArray[0].data.length; i++)
                    {
                        let dataTemp = [];
                        let time;
                        let value = 0;
                        for(let j = 0; j < sumDataArray.length; j++)
                        {
                            time = sumDataArray[j][i][0];
                            value += sumDataArray[j][i][1];
                        }
                        dataTemp.push(time);
                        dataTemp.push(String(Math.ceil(value)));
 
                        sumArray.push(dataTemp);
                    }
 
                    //sercie info table 의 bitrate 값 전달이 어려워 id로 처리
                    document.getElementById(`gid${llsInfo.gid}svcTbodyBitrate${item}`).textContent = unitBpsConvert(sumArray[sumArray.length - 1][1]);
                }
            });
        }
    }, [html]);
 
    return (
        <div className="section service-info">
            <div className="section-title">Service Info</div>
            <div className={`service-info-table-area subPage`}>
                <table className="table text-center table-sm">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>SvcId</th>
                            <th>Category</th>
                            <th>Bitrate</th>
                        </tr>
                    </thead>
                    <tbody>
                        {html}
                    </tbody>
                </table>
            </div>
        </div>
    )
}